import { RootState } from "@app/redux/root-reducer";

export const selectUsedCarsState = (store: RootState) =>
  store.usedCarsReducer.usedCars;

export const selectFilterCarsState = (store : RootState) => store.usedCarsReducer.filterCars